import dayjs from 'dayjs';
import * as yup from 'yup';

export interface SubscriptionEstimateFormValues {
  grossAmount: number | null;
  /** Entered positive; stored negative. The form never holds a negative reserve. */
  reserveAmount: number | null;
  startDate: Date | null;
  endDate: Date | null;
}

export const DEFAULT_SUBSCRIPTION_ESTIMATE_FORM_VALUES: SubscriptionEstimateFormValues =
  {
    grossAmount: null,
    reserveAmount: null,
    startDate: null,
    endDate: null,
  };

// Per-record rules only. Cross-record overlap/gap validation is a later stage.
export const SubscriptionEstimateValidationSchema = yup.object({
  grossAmount: yup
    .number()
    .nullable()
    .required('Gross amount is required')
    .min(0, 'Gross amount must be at least 0'),
  reserveAmount: yup
    .number()
    .nullable()
    .required('Reserve amount is required')
    .min(0, 'Reserve amount must be at least 0')
    .test(
      'reserve-not-exceeding-gross',
      'Reserve cannot exceed gross (net must not be negative)',
      function (value) {
        const { grossAmount } = this.parent;
        if (value == null || grossAmount == null) return true;
        return value <= grossAmount;
      },
    ),
  startDate: yup.date().nullable().required('Start date is required'),
  endDate: yup
    .date()
    .nullable()
    .test(
      'end-on-or-after-start',
      'End date must be on or after start date',
      function (value) {
        const { startDate } = this.parent;
        if (!value || !startDate) return true;
        return !dayjs(value).isBefore(dayjs(startDate), 'day');
      },
    ),
}) as yup.ObjectSchema<SubscriptionEstimateFormValues>;
